import Seo from "@/components/Seo";
import { Reveal } from "@/components/Motion";
import { Chapter, CtaBanner, PageHero, QuoteButtons } from "@/components/Sections";
import { B2B_CATEGORIES } from "@/lib/content";

const Erhverv = () => (
  <>
    <Seo
      title="Malerfirma for erhverv — B2B malerentreprenør & underentreprenør | Al Maler Mester ApS"
      description="Al Maler Mester ApS arbejder udelukkende B2B. Vi er malerentreprenør og underentreprenør for entreprenører, byggefirmaer, ejendomsselskaber, boligforeninger og facility management."
    />
    <PageHero
      overline="Erhverv · 100% B2B"
      title={
        <>
          En malerentreprenør, der taler{" "}
          <span className="font-editorial italic font-medium text-signal">byggeriets sprog</span>
        </>
      }
      lead="Vi arbejder udelukkende med erhvervskunder og professionelle samarbejdspartnere. Det betyder klar aftalestruktur, dokumenterbar planlægning og en koordinering, der respekterer både tidsplan og øvrige fag på projektet."
      image="/images/facade.jpg"
    />

    <section data-testid="b2b-customers-section" className="bg-ink text-bone grain py-24 md:py-32">
      <div className="max-w-[1440px] mx-auto px-5 md:px-10">
        <Chapter nr="01" label="Hvem vi arbejder for" dark />
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12">
          <Reveal className="lg:col-span-6">
            <h2 className="font-cabinet text-3xl sm:text-4xl font-bold tracking-tighter text-balance">
              Malerfirma for erhverv og professionelle samarbejdspartnere
            </h2>
            <p className="mt-6 text-bone/60 leading-relaxed">
              Al Maler Mester ApS er et rent B2B-malerfirma. Vi påtager os både løbende maleropgaver for faste
              erhvervskunder og projektbaserede entrepriser – som hovedentreprenør på malerfaget eller som
              underentreprenør i større byggesammenhænge.
            </p>
            <QuoteButtons className="mt-10" />
          </Reveal>
          <Reveal delay={0.15} className="lg:col-span-6">
            <div className="grid grid-cols-1 sm:grid-cols-2 border-t border-l border-bone/15">
              {B2B_CATEGORIES.map((c, i) => (
                <div
                  key={c}
                  data-testid={`erhverv-category-${i}`}
                  className="px-6 py-6 border-b border-r border-bone/15 hover:bg-bone/5 transition-colors duration-300"
                >
                  <span className="font-editorial italic text-signal text-sm">0{i + 1}</span>
                  <p className="mt-2 font-cabinet font-medium tracking-tight text-sm leading-snug">{c}</p>
                </div>
              ))}
            </div>
          </Reveal>
        </div>
      </div>
    </section>

    <section data-testid="subcontractor-section" className="py-24 md:py-32 max-w-[1440px] mx-auto px-5 md:px-10">
      <Chapter nr="02" label="Underentreprise" />
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-start">
        <Reveal className="lg:col-span-7">
          <h2 className="font-cabinet text-3xl sm:text-4xl font-bold tracking-tighter text-balance">
            Underentreprenør på malerfaget — en tryg samarbejdspartner på byggepladsen
          </h2>
          <p className="mt-6 text-soot leading-relaxed">
            For entreprenører og byggefirmaer indgår vi som malerunderentreprenør på nybyggeri, renovering og
            ombygning. Vi tilpasser os projektets styring, møder forberedt ind til byggemøder og koordinerer
            direkte med projektledere og øvrige faggrupper.
          </p>
          <p className="mt-4 text-soot leading-relaxed">
            Vores mål er enkelt: at levere malerfaget til tiden, i den aftalte kvalitet og uden friktion mod de
            øvrige entrepriser.
          </p>
        </Reveal>
        <Reveal delay={0.15} className="lg:col-span-5">
          <div className="bg-white border border-ink/10 p-8 md:p-10 grain">
            <p className="text-[10px] uppercase tracking-[0.25em] text-soot mb-6">Det kan I forvente</p>
            <ul className="space-y-5">
              {[
                "Konkret og gennemarbejdet tilbud med klart arbejdsomfang",
                "Tilslutning til projektets tidsplan og byggestyring",
                "Fleksibel bemanding efter projektets faser",
                "Løbende og direkte kommunikation med projektledelsen",
                "Professionel aflevering af det færdige arbejde",
              ].map((item, i) => (
                <li key={i} data-testid={`subcontractor-point-${i}`} className="flex gap-4 text-sm leading-relaxed">
                  <span className="w-1.5 h-1.5 bg-signal rotate-45 mt-2 shrink-0" />
                  {item}
                </li>
              ))}
            </ul>
          </div>
        </Reveal>
      </div>
    </section>

    <CtaBanner
      title="Har jeres virksomhed brug for en maler eller underentreprenør?"
      text="Kontakt os for en dialog om opgaven – vi tilpasser os jeres projekt, tidsplan og krav."
    />
  </>
);

export default Erhverv;
